import "./navbar.css";
import Logo from "../../images/VIBE-Logo-New.png";
import { Link, useHistory } from "react-router-dom";
import { useState, useEffect } from "react";
import { Avatar } from "antd";
import { Drawer, Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { PospLogin } from "../LoginPage/PospLogin";
import { PospForgetPassword } from "../LoginPage/ForgetPassword";
import { TokenExpired, OnSendReq } from "../../Redux/actions/NumBikeation";
import moment from "moment";
import { PospMenu } from "../Posp/Menu";
import { CaretDownOutlined } from "@ant-design/icons";
import TollImg from "../../assets/icons/helpline-person.png";

export const Navbar = () => {
  const Posp = useSelector((state) => state?.posp?.Posp);
  const ChangePass = useSelector((state) => state?.posp?.isChangePass);
  const Login = useSelector((state) => state?.posp?.Login);
  const TokExp = useSelector((state) => state?.common?.pospTokenExp);
  const QuoteRequest = useSelector((state) => state?.common?.quoteRequest);
  const dispatch = useDispatch();
  const [show, setshow] = useState(false);
  const [user, setuser] = useState("");
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(ChangePass);
  const [ShowPassword, setShowPassword] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [DrawClick, setDrawClick] = useState("");
  // console.log("DrawClick", DrawClick);
  console.log("QuoteRequest", QuoteRequest);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const isuser = Posp?.name;
    // console.log("TokExp", TokExp);
    // console.log("isuser", isuser);
    if (isuser) {
      const createdAt = moment.utc(Posp?.token?.created_at);
      const expiresAt = moment.utc(Posp?.token?.expires_at);
      const currentTime = moment.utc();

      const elapsedTime = currentTime.diff(createdAt);
      const timeUntilExpiry = expiresAt.diff(createdAt);
      console.log("expiresAtttt", expiresAt);
      const isExpired = elapsedTime >= timeUntilExpiry;

      console.log("Is token expired:", isExpired);
      dispatch(TokenExpired(isExpired));
      if (isExpired) {
        setuser("");
      } else {
        setuser(Posp);
      }
    } else {
      setuser("");
    }
  }, [Posp, user, ChangePass]);
  // console.log("Posp", Posp);
  // console.log("user", user);
  const showDrawer = () => {
    setDrawClick("");
    setOpen(true);
    const updateQuoteReq = {
      ...QuoteRequest,
      quoteRequest: true,
    };
    dispatch(OnSendReq(updateQuoteReq));
  };
  const onClose = () => {
    setOpen(false);
    const updateQuoteReq = {
      ...QuoteRequest,
      quoteRequest: false,
    };
    dispatch(OnSendReq(updateQuoteReq));
  };

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
      // console.log(scrolled);
    } else {
      setScrolled(false);
      // console.log(scrolled);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setShowPassword(false);
  };
  const handleLogout = () => {
    localStorage.removeItem("vibeUser");
    dispatch((dispatch) => {
      dispatch({ type: "LOGOUT_POSP" });
      dispatch({ type: "RESET_STATE" });
    });
    setuser("");
    history.push("/");
  };

  return (
    <>
      <nav
        className={
          scrolled
            ? `sticky-nav navbar navbar-expand-lg navbar-dark bg-white container px-3 py-0`
            : `navbar navbar-expand-lg navbar-dark bg-white container px-0 py-0`
        }
      >
        <div className="container-fluid px-0">
          <Link
            to="/"
            className="d-flex align-items-center text-decoration-none"
          >
            <img
              loading="eager"
              src={Logo}
              className="navbar-brand mt-0 position-relative"
              style={{ maxWidth: "125px" }}
              alt=""
            />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse justify-content-between"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav mb-2 mb-lg-0 gap-3 px-2">
              <li className="nav-item dropdown">
                <a
                  className="nav-link_B active dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Products
                </a>
                <ul className="dropdown-menu">
                  <Link to="">
                    <li className="dropdown-item">Bike</li>
                  </Link>
                  <Link to="">
                    <li className="dropdown-item">Car</li>
                  </Link>
                  <li className="dropdown-item">Commercial</li>
                  <li className="dropdown-item">Life</li>
                  <li className="dropdown-item">Health</li>
                  <li className="dropdown-item">Travel</li>
                  {/* <li className="nav-item dropend">
                  <a className="nav-link_B dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Dropdown
                  </a>
                  <ul className="dropdown-menu">
                    <li><a className="dropdown-item" href="#">Bike</a></li>
                    <li><a className="dropdown-item" href="#">Car</a></li>
                  </ul>
                </li> */}
                </ul>
              </li>
              <li className="nav-item nav-link_B">Renewals</li>
              <li className="nav-item nav-link_B">File a Claim</li>
              {/* <li className="nav-item">
                <a className="nav-link_B" href="#">
                  Resources
                </a>
              </li> */}
              <li className="nav-item dropdown">
                <a
                  className="nav-link_B dropdown-toggle"
                  href="#"
                  role="button"
                  aria-haspopup="true"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Contact
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a className="dropdown-item" href="#">
                      +917824077700
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="#">
                      contact@vibeins.com
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <div className="d-flex justify-content-center align-items-center gap-3">
              {!user ? (
                <>
                  <Link
                    to="/become-posp"
                    className="my-2 mx-3 mx-md-0 my-md-0 me-md-2"
                  >
                    <button className="btn btn-warning" type="button">
                      Become A POSP
                    </button>
                  </Link>
                  <button
                    className="btn btn btn-primary my-2 mx-3 mx-md-0 my-md-0 me-md-2"
                    type="button"
                    onClick={showModal}
                  >
                    POSP Log-In
                  </button>
                </>
              ) : (
                <>
                  <div
                    onClick={showDrawer}
                    className="d-flex align-items-center cursor-pointer"
                  >
                    <Avatar
                      size={24}
                      style={{
                        backgroundColor: "#273592",
                        color: "#fff",
                      }}
                    >
                      {user?.name[0] ?? "U"}
                    </Avatar>{" "}
                    <p className="mb-0 ms-2 d-flex align-items-center gap-2">
                      {user?.name}
                      <CaretDownOutlined />
                    </p>
                  </div>
                </>
              )}

              <div className="toll-free">
                <img src={TollImg}></img>18008 902 906
              </div>
            </div>
          </div>
          <Modal
            title={ShowPassword ? "Forgot Password" : "POSP LOGIN"}
            width={350}
            maskClosable={false}
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
          >
            {ShowPassword ? (
              <PospForgetPassword
                setIsModalOpen={setIsModalOpen}
                setShowPassword={setShowPassword}
              />
            ) : (
              <PospLogin
                setIsModalOpen={setIsModalOpen}
                setShowPassword={setShowPassword}
              />
            )}
          </Modal>
          <Drawer
            title="POSP Menu"
            className="open-posp"
            width={DrawClick ? `100%` : 312}
            // closable={false}
            maskClosable={false}
            onClose={onClose}
            open={open}
          >
            <PospMenu
              setDrawClick={setDrawClick}
              open={open}
              setOpen={setOpen}
              setuser={setuser}
            />
          </Drawer>
        </div>
      </nav>
    </>
  );
};
